import TeamImage from 'components/TeamImage';
import ContentSection, { ContentSectionHeader, ContentSectionProps } from '../ContentSection';
import styles from './styles/CalloutModule.module.scss';
import { Fragment, ReactNode } from 'react';
import { SectionHeaderSize } from '../SectionHeader';

export default function CalloutModule({
  title,
  right,
  topText,
  entity,
  bottomText,
  footer,
  ...props
}: Omit<ContentSectionProps, 'children'> & {
  title: string;
  right?: ReactNode;
  topText?: ReactNode;
  entity: { image?: string; name: string } | { image?: string; name: string }[];
  bottomText?: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <ContentSection {...props}>
      <ContentSectionHeader right={right} size={SectionHeaderSize.LARGE}>
        {title}
      </ContentSectionHeader>
      <div className={styles.Container}>
        <div className={styles.TopText}>{topText}</div>
        <div className={styles.Entity}>
          {[entity].flat().map((ent, i) => (
            <Fragment key={i}>
              {i === 1 && <div className={styles.Versus}>vs</div>}
              <TeamImage className={styles.Image} src={ent.image} alt={ent.name} />
            </Fragment>
          ))}
        </div>
        <div className={styles.BottomText}>{bottomText}</div>
      </div>
      {footer && <div className={styles.Footer}>{footer}</div>}
    </ContentSection>
  );
}
